enum ProductType {
    Software = 'software',
    Hardware = 'hardware'
}

export default ProductType;